import React, { Suspense, lazy } from 'react'

// This defines all available SVG imports.
const svgImportMap: Record<string, () => Promise<{ default: React.ComponentType<any> }>> = {
  ArrowLeftIcon: () => import('../assets/SVGs/ArrowLeft'),
  BarsIcon: () => import('../assets/SVGs/Bars'),
  ConnectionOnIcon: () => import('../assets/SVGs/ConnectionOn'),
  ConnectionOffIcon: () => import('../assets/SVGs/ConnectionOff'),
  CreateConnectionsIcon: () => import('../assets/SVGs/CreateConnections'),
  ICircleIcon: () => import('../assets/SVGs/ICircle'),
  InfoIcon: () => import('../assets/SVGs/Info'),
  LightAndDarkModeIcon: () => import('../assets/SVGs/LightAndDarkMode'),
  MapIcon: () => import('../assets/SVGs/Map'),
  OutgoingLinkIcon: () => import('../assets/SVGs/OutgoingLink'),
  ProfileIcon: () => import('../assets/SVGs/Profile'),
  RtkSignalIcon: () => import('../assets/SVGs/RtkSignal'),
  SearchIcon: () => import('../assets/SVGs/Search'),
  SourceAccountIcon: () => import('../assets/SVGs/SourceAccount'),
  StackIcon: () => import('../assets/SVGs/Stack'),
  StarOutlineIcon: () => import('../assets/SVGs/StarOutline'),
  StarSolidIcon: () => import('../assets/SVGs/StarSolid'),
  SubscriptionIcon: () => import('../assets/SVGs/Subscription'),
  SuccessIcon: () => import('../assets/SVGs/Success'),
  WarningIcon: () => import('../assets/SVGs/Warning'),
}
export type LazySVGImportMap = "ArrowLeftIcon" | "BarsIcon" | "ConnectionOnIcon" | "ConnectionOffIcon" | "MapIcon" | "LightAndDarkModeIcon" | 'StarOutlineIcon' | "StarSolidIcon" | "InfoIcon" | "SuccessIcon" | "WarningIcon" | "RtkSignalIcon" | "ICircleIcon" | "ProfileIcon" | "SourceAccountIcon" | "OutgoingLinkIcon" | "StackIcon" | "CreateConnectionsIcon" | "SubscriptionIcon" | "SearchIcon"


export type SVGProps = {
  name: LazySVGImportMap
  className?: string
  color?: string
  width: number
  height: number
}


const LazySVG: React.FC<SVGProps> = ({ name, width = '1em', height = '1em', ...props }) => {
  const ImportedSVG = lazy(svgImportMap[name] || (() => Promise.reject(new Error('SVG not found'))))

  return (
    <Suspense
      fallback={
        <span
          style={{ width, height }}
          className="inline-block animate-pulse rounded-full bg-current"
        />
      }
    >
      <ImportedSVG width={width} height={height} {...props} />
    </Suspense>
  )
}

export default LazySVG
